export enum SLIDER {
  MIN = -30,
  MID = 50,
  MAX = 130,
}

export enum FACE_STATE {
  MIN_MISERABLE = SLIDER.MIN,
  MAX_MISERABLE = -10,
  MIN_SAD = -10,
  MAX_SAD = 20,
  MIN_DEPRESSED = 20,
  MAX_DEPRESSED = SLIDER.MID - 10,
  MIN_CALM = SLIDER.MID - 10,
  MAX_CALM = 60,
  MIN_SMILING = 60,
  MAX_SMILING = 80,
  MIN_HAPPY = 80,
  MAX_HAPPY = 100,
  MIN_CHEERFUL = 100,
  MAX_CHEERFUL = SLIDER.MAX,
}
